import type { MultilingualRefs } from './types'
import { getSiteFeatureBoundRefProvider } from '../../utils/refProvider'

const featureName = 'multilingual'
const multilingualRefProvider = getSiteFeatureBoundRefProvider(featureName)

const multilingualRefs: MultilingualRefs = {
	originalLanguageCode: () => multilingualRefProvider(['originalLanguageCode']),
	currentLanguage: () => multilingualRefProvider(['currentLanguage']),
	siteLanguages: () => multilingualRefProvider(['siteLanguages']),
	flagsUrl: () => multilingualRefProvider(['flagsUrl']),
	setCurrentLanguage: () => multilingualRefProvider(['setCurrentLanguage']),
}

export { multilingualRefs }
